import React from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";

const operations = ["+", "-"];

interface InputsProps {
  numbers: number[];
  handleNumPress: Function;
  handleOperationPress: Function;
  handleDelete: Function;
  handleSolve: Function;
  currentSquare: number;
  gameStateRow: string[];
  isWinner: boolean;
}

const hasPickedNum = (gameStateRow: string[] = [], num: number) => {
  for (let i = 0; i < gameStateRow.length; i++) {
    try {
      const parsedNum = parseInt(gameStateRow[i]);
      if (parsedNum === num) {
        return true;
      }
    } catch (e) {
      //ok
    }
  }
  return false;
};

const Inputs = ({
  handleNumPress,
  handleOperationPress,
  handleDelete,
  handleSolve,
  numbers,
  currentSquare,
  gameStateRow,
  isWinner,
}: InputsProps) => {
  return (
    <div>
      <ButtonGroup>
        {numbers.map((num) => (
          <Button
            style={{
              margin: "5px",
            }}
            colorScheme="teal"
            variant="outline"
            isDisabled={
              currentSquare % 2 !== 0 ||
              hasPickedNum(gameStateRow, num) ||
              isWinner
            }
            onClick={() => handleNumPress(num)}
          >
            {num}
          </Button>
        ))}
      </ButtonGroup>
      <div>
        {operations.map((op) => (
          <Button
            style={{
              margin: "5px",
            }}
            variant="outline"
            colorScheme="teal"
            isDisabled={currentSquare % 2 === 0 || isWinner}
            onClick={() => handleOperationPress(op)}
          >
            {op}
          </Button>
        ))}
      </div>
      <ButtonGroup>
        <Button
          colorScheme="teal"
          variant="outline"
          isDisabled={currentSquare !== 7 || isWinner}
          onClick={() => handleSolve()}
        >
          Solve
        </Button>

        <Button
          colorScheme="teal"
          variant="outline"
          isDisabled={currentSquare === 0 || isWinner}
          onClick={() => handleDelete()}
        >
          Delete
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Inputs;
